import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';
import { WindowService } from '../../shared/window.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { BehaviorSubject } from 'rxjs';
import { LiveClassService } from '../../home/live-class.service';

export enum PrivateClassEventType {
  GO_TO_HOME = 'GoToHome',
}

@Component({
  selector: 'lp2-private-classes-page',
  template: `
    <section *ngIf="privateClassesPageFrameUrl | async as url; else loading" class="private-classes-page">
      <iframe lp2UserwaySync class="PrivateClassesPageIFrame" [src]="url | safeUrl"></iframe>
    </section>

    <ng-template #loading>
      <div style="height: 140px"></div>
      <div class="content d-flex align-items-center">
        <div class="loader"></div>
      </div>
    </ng-template>
  `,
  styleUrls: ['./private-classes-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateClassesPageComponent implements OnInit, OnDestroy {
  public privateClassesPageFrameUrl = new BehaviorSubject<string>(null);
  public hasPrivateClasses: boolean;
  private boundHandler: (event: MessageEvent) => void;

  constructor(
    private oeApp: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    private windowService: WindowService,
    private liveClassService: LiveClassService
  ) {}

  async ngOnInit() {
    this.hasPrivateClasses = await this.liveClassService.getHasPrivateClasses().toPromise();

    if (this.hasPrivateClasses) {
      this.privateClassesPageFrameUrl.next(
        `${this.oeApp.webPrivateClassesHost}` +
          `?env=${this.oeApp.environment}` +
          `&contactId=${this.oeAppPersonService.contactId}` +
          `&lang=${this.oeAppPersonService.preferredLang}` +
          `&lfa=${this.oeAppPersonService.isLfa}`
      );

      this.boundHandler = this.handleEvents.bind(this);
      window.addEventListener('message', this.boundHandler, false);
    } else {
      this.windowService.redirectToHref('/');
    }
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.boundHandler);
  }

  public handleEvents({ data, origin }) {
    if (!isIFrameSameOrigin(this.oeApp.webPrivateClassesHost, origin)) {
      return;
    }

    const type: PrivateClassEventType = data.type;

    switch (type) {
      case PrivateClassEventType.GO_TO_HOME:
        this.windowService.redirectToHref('/');
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/private-classes/private-classes-page/private-classes-page.component.ts